import { makeAutoObservable } from "mobx";
import { InteractionRequiredAuthError, InteractionStatus, RedirectRequest } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Account } from "../models/account";

export class UserStore {
    user: Account | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setUser = (account: Account) => {
        this.user = account;
    }

    get isLoggedIn(): boolean {
        return !!this.user;
    }

    get isAdmin(): boolean {
        return this.user != null && this.user.userRole.toLowerCase() === "admin";
    }

    login = async () => {
        const { instance } = useMsal();
        instance.loginRedirect();
    }

    logout = () => {
        const { instance } = useMsal();
        instance.logoutRedirect();
    }

    getAccessToken = async () => {
        const { instance, inProgress, accounts } = useMsal();
        const accessTokenRequest = {
            scopes: ["api://d3df106d-b0da-4981-a1a8-2672c8b1b26b/access_as_user"],
            account: accounts[0],
        };
        try {
            let accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
            let accessToken = accessTokenResponse.accessToken;
            return accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                instance
                    .acquireTokenPopup(accessTokenRequest)
                    .then(function (accessTokenResponse) {
                        // Acquire token interactive success
                        let accessToken = accessTokenResponse.accessToken;
                        return accessToken;
                    })
                    .catch(function (error) {
                        // Acquire token interactive failure
                        console.log(error);
                        return "";
                    });
            }
        }

    }
}